module.exports = __webpack_public_path__ + "tables/media/Grid_filled.bd3025cb.svg";